// src/pages/ForgotPassword.js
import React, { useState } from 'react';
import { TextField, Button, Container, Typography } from '@mui/material';
import authService from '../services/authService';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await authService.forgotPassword(email);
      alert('Password reset link sent!');
    } catch (error) {
      console.error('Error sending reset link', error);
    }
  };

  return (
    <Container maxWidth="sm">
      <Typography variant="h4">Forgot Password</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Email"
          fullWidth
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button type="submit" variant="contained" color="primary" fullWidth>
          Send Reset Link
        </Button>
      </form>
    </Container>
  );
};

export default ForgotPassword;
